import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7d3dd01f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-chip" }
const _hoisted_2 = { class: "p-r-5" }
const _hoisted_3 = { class: "pi pi-info-circle icon-right p-t-2" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "data-segment": 1,
  class: "pi pi-ellipsis-v"
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]

import { ref, onMounted, computed } from "vue";
import { useEstimationParamsDictionaryStore } from "@/store/catalog_data/estimations_params";
import { useEstimationsSettingsStore } from "@/store/analytics/estimation_settings";
import { useHistoryStore } from "@/store/history/history";
import { useAuthStore } from "@/store/auth/login";
import UserCustomHistoryDialog from "@/widgets/dialogs/UserCustomHistoryDialog.vue";

import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Menu from "primevue/menu";
import InputText from "primevue/inputtext";
import { getHistories } from "@/services/analytics/estimation_settings";
import DeleteConfirmDialog from "@/shared/dialogs/DeleteConfirmDialog.vue";
import CatalogDataSingleInput from "@/widgets/forms/CatalogDataSingleInput.vue";

import { rootGetters } from "@/main";
import { useRouter } from "vue-router";
import { SettingsFromServer } from "@/store/analytics/estimation_settings";


export default /*#__PURE__*/_defineComponent({
  __name: 'EstimationSettingsTable',
  props: {
    estimationsSettings: {},
    isActiveFirst: { type: Boolean },
    isLoading: { type: Boolean },
    rowsCount: {}
  },
  emits: ["sortTable", "updateTable"],
  setup(__props: any, { emit: __emit }) {


const emits = __emit;
const store = useEstimationsSettingsStore();
const historyStore = useHistoryStore();
const paramsStore = useEstimationParamsDictionaryStore();
const authStore = useAuthStore();
const router = useRouter();

let modifiedId = ref({
  brand_pk: "",
  strategy: "",
});
const confirmVisibleDelete = ref(false);
const confirmVisibleHistory = ref(false);
const historyItems = ref<object[]>([]);
const blockedButtonDelete = ref(false);
const menu = ref();
const items = ref([
  {
    label: "История действий",
    icon: "pi pi-history",
    checkDenied: true,
    archive: "both",
    command: () => {
      store
        .getEstimationSettingsByBrandStrategy(
          modifiedId.value.brand_pk,
          modifiedId.value.strategy
        )
        .then((data) => {
          const ids = data.settings.map((item) => item.id);
          const settingsMap = new Map();

          data.settings.forEach((e) => {
            settingsMap.set(e.id, e.client_reports_params_id);
          });

          historyStore
            .fetchAllHistories("client_reports_settings", ids)
            .then((resp) => {
              if (resp) {
                historyItems.value = getHistories(
                  resp,
                  paramsStoreMap.value,
                  settingsMap
                );
              }
            });
          confirmVisibleHistory.value = true;
        });
    },
  },
  {
    label: "Редактировать по датам",
    icon: "pi pi-pencil",
    archive: "both",
    checkDenied: false,
    command: () => {
      router.push({
        name: "estimationSettingsDates",
        query: {
          brand_pk: modifiedId.value.brand_pk,
          strategy: modifiedId.value.strategy,
        },
      });
    },
  },
  {
    label: "Удалить",
    icon: "pi pi-trash",
    archive: "both",
    checkDenied: false,
    command: () => {
      confirmVisibleDelete.value = true;
    },
  },
]);

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(["history:edit"], ["history:read"]);
});

const filteredItems = computed(() => {
  return items.value.filter((item) => !(item.checkDenied && isDenied.value));
});

const loadData = () => {
  paramsStore.getItems();
};

onMounted(() => {
  loadData();
});

const paramsStoreMap = computed(() => {
  return new Map(paramsStore.itemList.map((item) => [item.id, item.name]));
});

const toggle = (elem: any, event: any) => {
  modifiedId.value.brand_pk = elem.brand_pk;
  modifiedId.value.strategy = elem.strategy;

  menu.value.toggle(event);
};

const sortTable = (event: any) => {
  let orderField = "";
  if (event.sortField) {
    if (event.sortField == "brand")
      orderField = event.sortOrder > 0 ? "brand_pk" : `-brand_pk`;
    else
      orderField =
        event.sortOrder > 0 ? event.sortField : `-${event.sortField}`;
  }

  emits("sortTable", orderField);
};

const deleteEstimation = () => {
  blockedButtonDelete.value = true;
  store
    .deleteEstimationSettings(
      modifiedId.value.brand_pk,
      modifiedId.value.strategy
    )
    .finally(() => {
      emits("updateTable");
      blockedButtonDelete.value = false;
      confirmVisibleDelete.value = false;
    })
    .catch((err) => {
      if (err.response && err.response.status == 400)
        rootGetters.toast.show("warn", "Ошибка", err.response.data.detail);
    });
};

const onCellEditComplete = (event: any) => {
  let { data, newValue, field } = event;

  if (field == "brand") {
    if (newValue["brand_pk"] != data["brand_pk"])
      store
        .updateBrandStrategy({
          new_brand_pk: newValue["brand_pk"],
          old_brand_pk: data["brand_pk"],
          old_strategy: data["strategy"],
          new_strategy: data["strategy"],
        })
        .then(() => {
          data["brand"] = newValue;
          data["brand_name"] = newValue["brand_name"];
          data["brand_pk"] = newValue["brand_pk"];
        })
        .catch((err) => {
          if (err.response && err.response.status == 409)
            rootGetters.toast.show("warn", "Ошибка", err.response.data.detail);
        });
  } else if (field == "strategy") {
    if (newValue != data["strategy"])
      store
        .updateBrandStrategy({
          new_brand_pk: data["brand_pk"],
          old_brand_pk: data["brand_pk"],
          old_strategy: data["strategy"],
          new_strategy: newValue,
        })
        .then(() => {
          data["strategy"] = newValue;
        })
        .catch((err) => {
          if (err.response && err.response.status == 409)
            rootGetters.toast.show("warn", "Ошибка", err.response.data.detail);
        });
  } else {
    const value = data["mapSettings"][field]["value"]
      .toString()
      .replace(/,/g, ".");
    store
      .updateEstimationSettingsValue(
        data["mapSettings"][field]["id"],
        parseFloat(value)
      )
      .then((dataValue) => {
        if (dataValue.value.toString() != value) {
          rootGetters.toast.show(
            "warn",
            "Ошибка",
            "Неверный формат ввода числа"
          );
        }
        data["mapSettings"][field]["value"] = dataValue.value.toString();
      })
      .catch((err) => {
        rootGetters.toast.show("warn", "Ошибка", err.response.data.detail);
      });
  }
};

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(DataTable), {
      value: _ctx.estimationsSettings,
      class: _normalizeClass([[
      _ctx.estimationsSettings && _ctx.estimationsSettings.length == 0
        ? 'empty-table'
        : '',
      _ctx.isActiveFirst ? 'active-first' : '',
    ], "scroll-table-y main-table scrollbar-custom"]),
      stripedRows: "",
      onSort: sortTable,
      editMode: "cell",
      removableSort: "",
      scrollable: "",
      loading: _ctx.isLoading,
      dataKey: "id",
      pt: {
      column: {
        bodycell: ({ state }) => ({
          class: [{ 'pt-0 pb-0': state['d_editing'] }],
        }),
      },
    },
      onCellEditComplete: onCellEditComplete
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Column), {
          field: "number",
          header: "№",
          style: {"min-width":"44px"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_ctx.rowsCount + slotProps.index + 1), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "brand",
          header: "Бренд",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", _hoisted_1, _toDisplayString(data["brand_name"]), 1)
          ]),
          editor: _withCtx(({ data }) => [
            _createVNode(CatalogDataSingleInput, {
              selectType: "brand",
              "use-id-only": false,
              isSegmentSetted: false,
              modelValue: data['brand'],
              "onUpdate:modelValue": ($event) => (data['brand'] = $event)
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "strategy",
          header: "Стратегия",
          sortable: ""
        }, {
          editor: _withCtx(({ data, field }) => [
            _createVNode(_unref(InputText), {
              modelValue: data[field],
              "onUpdate:modelValue": ($event: any) => ((data[field]) = $event),
              autofocus: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(paramsStore).itemList, (col) => {
          return (_openBlock(), _createBlock(_unref(Column), {
            key: col.id,
            field: col.id.toString()
          }, {
            header: _withCtx(() => [
              _createElementVNode("span", _hoisted_2, _toDisplayString(col.name), 1),
              _withDirectives(_createElementVNode("span", _hoisted_3, null, 512), [
                [_directive_tooltip, {
            value: col.description,
            class: 'white-tooltip',
          }]
              ])
            ]),
            body: _withCtx(({ data, field }) => [
              (field in data['mapSettings'])
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(data["mapSettings"][field]["value"]), 1))
                : _createCommentVNode("", true)
            ]),
            editor: _withCtx(({ data, field }) => [
              _createVNode(_unref(InputText), {
                modelValue: data['mapSettings'][field]['value'],
                "onUpdate:modelValue": ($event: any) => ((data['mapSettings'][field]['value']) = $event),
                autofocus: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1032, ["field"]))
        }), 128)),
        _createVNode(_unref(Column), {
          frozen: "",
          alignFrozen: "right"
        }, {
          body: _withCtx((slotProps) => [
            _createElementVNode("div", {
              onClick: (event) => toggle(slotProps.data, event),
              "aria-haspopup": "true",
              "aria-controls": "overlay_menu",
              class: "button-menu"
            }, _hoisted_7, 8, _hoisted_5)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "class", "loading", "pt"]),
    _createVNode(_unref(Menu), {
      ref_key: "menu",
      ref: menu,
      id: "overlay_menu",
      model: filteredItems.value,
      popup: true
    }, null, 8, ["model"]),
    _createVNode(DeleteConfirmDialog, {
      "deleted-name": "настройки эстимации",
      visible: confirmVisibleDelete.value,
      blocked: blockedButtonDelete.value,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (confirmVisibleDelete.value = false)),
      onDelete: deleteEstimation
    }, null, 8, ["visible", "blocked"]),
    _createVNode(UserCustomHistoryDialog, {
      items: historyItems.value,
      visible: confirmVisibleHistory.value,
      "creation-skip": true,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (confirmVisibleHistory.value = false))
    }, null, 8, ["items", "visible"])
  ], 64))
}
}

})